import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createAiSearchBaseActions, createAiSearchStore, initialAiSearchBaseState } from '~/hooks/reactQuery/createAiSearchStore';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
const store = createAiSearchStore([
    QueryKeys.AgreementsAiSearchState
], initialAiSearchBaseState());
const actions = _object_spread_props(_object_spread({}, createAiSearchBaseActions(store)), {
    editFilter: (filter)=>store.setState(filter == null ? {
            filter: null,
            lastQuery: '',
            filterEditedSinceLastSearch: false
        } : {
            filter,
            filterEditedSinceLastSearch: true
        })
});
export const useAgreementsAiSearchStore = Object.assign((selector)=>store.useStore((data)=>selector(_object_spread({}, data, actions))), {
    getState: ()=>_object_spread({}, store.getState(), actions),
    setState: store.setState
});
